import { action } from 'mobx';

/**
 * 'efficiently' sync mobX 'observableArray' with new items
 */
export const syncObservableArray = action(
  (observableArray, itemsToSync, resolveId) => {
    const prevIds = observableArray.map(resolveId);
    const nextIds = itemsToSync.map(resolveId);

    const removedIds = prevIds.filter((id) => !nextIds.includes(id));
    const addedIds = nextIds.filter((id) => !prevIds.includes(id));
    const remainedIds = nextIds.filter(
      (id) => !removedIds.includes(id) && !addedIds.includes(id)
    );

    const addedItems = itemsToSync.filter((item) =>
      addedIds.includes(resolveId(item))
    );
    const removedItems = observableArray.filter((item) =>
      removedIds.includes(resolveId(item))
    );
    const remainedItems = observableArray.filter((item) =>
      remainedIds.includes(resolveId(item))
    );

    // removing old items
    removedItems.map((item) => {
      const index = observableArray.indexOf(item);
      observableArray.splice(index, 1);
    });

    // adding new items
    addedItems.forEach((item) => {
      observableArray.push(item);
    });

    // updating properties of remained items
    remainedItems.forEach((remainedItem) => {
      const index = observableArray.indexOf(remainedItem);
      const updated = itemsToSync.find(
        (updatedItem) => resolveId(updatedItem) === resolveId(remainedItem)
      );
      Object.keys(updated).forEach((key) => {
        observableArray[index][key] = updated[key];
      });
    });
  }
);
